import {seoCity} from '@/js/sections/seo-city.js';

class CatalogFilter {
	constructor() {
		this.filterState = null;
		this.lastUrl = window.location.href.includes('bonus') ? '' : window.location.href;
		this.locale = Shopify.locale;
		this.seoCitySlider = seoCity;
		this.debounceTimeout = null;
		this.historyUrl = this.getHistoryUrl();
		this.classes = {
			catalog: 'catalog',
			swatchActive: 'is-active-filter',
			switchActive: 'catalog__switch--active',
			switch: '.catalog__switch',
			removeFacet: 'js-remove-facet',
			clearFacets: 'js-clear-facets',
			facetItem: 'facets__item',
			clearFacetItem: 'facets__item--clear',
			checkbox: '.filter__item-checkbox',
			checkboxActive: 'filter__item-checkbox--active',
			itemActive: 'is-active-filter',
			groupExpanded: 'filter__group--expanded',
			groupHeading: '.filter__group-heading',
			headingItem: '.filter__heading-item',
			toggleFilter: 'js-toggle-filter',
			filterVisible: 'catalog__aside--visible',
			asideClose: 'js-aside-close',
			cancelFilterXp: 'js-filter-cancel',
			catalogPinSet: 'catalog--pin-set',
			filterItem: 'js-filter-item',
			filterItemActive: 'is-active-filter',
		};

		this.init();
	}

	prepareFilterItems() {
		let allTastestSwatch = document.querySelector('.filter__swatch--noicon');
		if (allTastestSwatch) {
			allTastestSwatch.classList.add('js-filter-item');
		}

		let items = document.querySelectorAll('.catalog__aside-products .filter__item');
		items.forEach((item) => {
			const labelEl = item.querySelector('.filter__item-name');
			if (labelEl) {
				const itemValue = labelEl.dataset.value;

				if (itemValue == 'all' || labelEl.innerText.toLowerCase().includes('всі')) {
					item.classList.add('js-filter-item');
				}
			}
		});
	}

	isMobile() {
		return window.innerWidth <= 1024;
	}

	handleFilterItems() {

		document.body.addEventListener('change', (event) => {
			const target = event.target;
			if (target.tagName === 'INPUT' && target.type === 'checkbox') {

				const filterItem = target.closest('.filter__item, .filter__swatch, .filter__heading-item, .catalog-main__filters-item');
				if (filterItem) {
					this.processFilterClick(filterItem, target.checked);
				}
			}
		});

		document.body.addEventListener('click', (event) => {
			const filterItem = event.target.closest('.filter__item, .filter__swatch, .filter__heading-item, .catalog-main__filters-item');

			if (filterItem && event.target.tagName !== 'INPUT') {
				const checkbox = filterItem.querySelector('input[type="checkbox"]');
				if (checkbox) {
					event.preventDefault();
					checkbox.checked = !checkbox.checked;
					checkbox.dispatchEvent(new Event('change', { bubbles: true }));
				}
			}
		});
	}

	resetToAllProducts() {
		this.uncheckAllFilterCheckboxes();

		const facetsWrapper = document.querySelector('.facets');
		if (facetsWrapper) facetsWrapper.innerHTML = '';

		document.querySelectorAll('.catalog-main__filters-item').forEach(el => {
			const isAll = el.dataset.name === 'all' && el.dataset.value === 'all';
			el.classList.toggle(this.classes.filterItemActive, isAll);
		});

		const select = document.querySelector('#select-product');
		if (select) {
			const option = Array.from(select.options).find(opt => {
				const ov = opt.dataset.value || opt.value;
				return ov === 'all';
			});

			if (option) {
				select.value = option.value;

				if (select.tomselect) {
					select.tomselect.setValue(option.value, true);
				}
			}
		}

		const url = new URL(window.location.href);

		['devices', 'sticks', 'accessories', 'device', 'page'].forEach(p => url.searchParams.delete(p));

		url.searchParams.delete('bonus');

		const qs = url.searchParams.toString();
		const cleanUrl = url.pathname + (qs ? `?${qs}` : '');

		window.history.replaceState({}, '', cleanUrl);

		this.updateCatalogFromPage(1);
	}

	handleMainFilters(evt) {
		const btn = evt.currentTarget;
		const category = this.getMainCategoryFromButton(btn);
		if (!category) return;

		this.setMainCategory(category);
	}

	handleSelectFilters(evt) {
		const select = evt.currentTarget;
		const category = this.getMainCategoryFromSelect(select);
		if (!category) return;

		this.setMainCategory(category);
	}

	getMainCategoryFromButton(btn) {
		if (!btn) return null;

		const name = btn.dataset.name;
		const value = btn.dataset.value;

		if (name === 'all' && value === 'all') return 'all';

		if (['devices', 'sticks', 'accessories'].includes(name) && value === 'all') {
			return name;
		}

		if (['devices', 'sticks', 'accessories'].includes(value)) {
			return value;
		}

		return null;
	}

	getMainCategoryFromSelect(select) {
		if (!select) return null;

		const opt = select.options[select.selectedIndex];
		if (!opt) return null;

		const raw = opt.dataset.value || opt.value;

		if (raw === 'all') return 'all';
		if (['devices', 'sticks', 'accessories'].includes(raw)) return raw;

		return null;
	}

	setMainCategory(category) {
		if (!category) return;

		if (category === 'all') {
			this.resetToAllProducts();
			return;
		}

		this.syncWithSidebar(category, 'all');

		document.querySelectorAll('.catalog-main__filters-item').forEach(el => {
			const n = el.dataset.name;
			const v = el.dataset.value;

			const isActive =
				(n === category && v === 'all') ||
				(n === category && v === category);

			el.classList.toggle(this.classes.filterItemActive, isActive);
		});

		const select = document.querySelector('#select-product');
		if (select) {
			const option = Array.from(select.options).find(opt => {
				const ov = opt.dataset.value || opt.value;
				return ov === category;
			});

			if (option) {
				select.value = option.value;

				if (select.tomselect) {
					select.tomselect.setValue(option.value, true);
				}
			}
		}

		this.updateCatalogFromPage();
	}

	syncSelectWithMainFilters() {
		const select = document.querySelector('#select-product');
		const activeBtn = document.querySelector(`.catalog-main__filters:not(.catalog-main__filters--xp) .catalog-main__filters-item.${this.classes.filterItemActive}`);
		const category = this.getMainCategoryFromButton(activeBtn);
		if (!select || !category) return;

		const option = Array.from(select.options).find(opt => (opt.dataset.value || opt.value) === category);
		if (!option) return;

		select.value = option.value;

		if (select.tomselect) {
			select.tomselect.setValue(option.value, true);
		}
	}

	syncWithSidebar(name, value) {
		const aside = document.querySelector('.catalog__aside-products');
		if (!aside) return;

		if (name === 'all' && value === 'all') {
			aside.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
				const filterItem = checkbox.closest('.filter__item, .filter__swatch, .filter__heading-item');
				const itemLabel = filterItem?.querySelector('.filter__item-name, .filter__swatch-label');
				const itemName = itemLabel?.dataset.name || checkbox.name;
				const itemValue = itemLabel?.dataset.value || checkbox.value;

				if (['devices', 'sticks', 'accessories'].includes(itemName)) {
					if (itemValue === 'all') {
						checkbox.checked = true;
						filterItem?.classList.add(this.classes.filterItemActive);
					} else {
						checkbox.checked = false;
						filterItem?.classList.remove(this.classes.filterItemActive);
					}
				}
			});
			return;
		}
		const checkboxes = aside.querySelectorAll(`input[type="checkbox"]`);
		checkboxes.forEach(checkbox => {
			const filterItem = checkbox.closest('.filter__item, .filter__swatch, .filter__heading-item');

			const itemLabel = filterItem?.querySelector('.filter__item-name, .filter__swatch-label');
			
			const itemName = itemLabel?.dataset.name || checkbox.name;
			const itemValue = itemLabel?.dataset.value || checkbox.value;

			if (itemName === name) {
				const isActive = itemValue === value;
				checkbox.checked = isActive;
				filterItem?.classList.toggle(this.classes.filterItemActive, isActive);
			} else if (['devices', 'sticks', 'accessories'].includes(itemName)) {
				checkbox.checked = false;
				filterItem?.classList.remove(this.classes.filterItemActive);
			}
		});
	}

	syncMainFilters(name, value, isActive) {

		let mainName = 'all';
		let mainValue = 'all';

		if (isActive) {
			mainName = name;
			mainValue = value;
		}

		document.querySelectorAll('.catalog-main__filters-item').forEach(el => {
			const isMatch = el.dataset.name === mainName && el.dataset.value === mainValue;
			el.classList.toggle(this.classes.filterItemActive, isMatch);
		});

		const select = document.querySelector('#select-product');
		if (select) {
			const option = Array.from(select.options).find(opt => opt.dataset.name === mainName && opt.dataset.value === mainValue);
			if (option) {
				select.value = option.value;
				if (select.tomselect) {
					select.tomselect.setValue(option.value, true);
				}
			}
		}
	}

	processFilterClick(item, isChecked) {
		if(item.closest('.catalog__aside-xp')) return;

		const checkbox = item.querySelector('input[type="checkbox"]');

		const isItemActive = isChecked;

		item.classList.toggle(this.classes.filterItemActive, isItemActive);

		const labelEl = item.querySelector('.filter__item-name, .filter__swatch-label, .filter__heading-text');
		const itemName = labelEl?.dataset.name || item.dataset.name || (item.querySelector('input[type="checkbox"]')?.name);
		const itemValue = labelEl?.dataset.value || item.dataset.value || (item.querySelector('input[type="checkbox"]')?.value);

		if (item.closest('.catalog__aside-products') && ['devices', 'sticks', 'accessories', 'all'].includes(itemName)) {
			this.syncMainFilters(itemName, itemValue, isItemActive);
		}

		if (labelEl || item.classList.contains('filter__heading-item') || item.classList.contains('catalog-main__filters-item')) {
			const parent = item.closest('.filter__items, .filter__swatches, .filter__category, .catalog-main__filters');
			
			if (parent) {
				const hasAllItemsCheckbox = !!parent.querySelector('[data-value=all]');
				const isAllDevicesActive = this.isAllDevicesSelected();

				this.checkTasteItems(item, isItemActive);

				if (isAllDevicesActive && itemValue !== 'all' && itemName === 'devices') {
					const allDevicesItem = parent.querySelector('[data-name="devices"][data-value="all"]');
					const allDevicesFilterItem = allDevicesItem?.closest('.filter__item, .catalog-main__filters-item');
					if (allDevicesFilterItem) {
						allDevicesFilterItem.classList.remove(this.classes.filterItemActive);
						const allCheckbox = allDevicesFilterItem.querySelector('input[type="checkbox"]');
						if (allCheckbox) allCheckbox.checked = false;
					}
					item.classList.add(this.classes.filterItemActive);
				} else if (isAllDevicesActive && itemValue === 'all') {
					this.disableSingularDevicesFilters();
				}

				if (hasAllItemsCheckbox) {
					const allItems = Array.from(parent.querySelectorAll('.filter__item, .filter__swatch, .catalog-main__filters-item'));
					const firstItem = allItems[0];
					const otherItems = allItems.slice(1);
					const selectedOtherItems = otherItems.filter(i => i.classList.contains(this.classes.filterItemActive));

					if (itemValue === 'all') {
						if (isItemActive) {
							otherItems.forEach((childItem) => {
								childItem.classList.remove(this.classes.filterItemActive);
								const childCheckbox = childItem.querySelector('input[type="checkbox"]');
								if (childCheckbox) childCheckbox.checked = false;
							});
						}
					} else {
						if (isItemActive && firstItem) {
							firstItem.classList.remove(this.classes.filterItemActive);
							const firstCheckbox = firstItem.querySelector('input[type="checkbox"]');
							if (firstCheckbox) firstCheckbox.checked = false;
						}

						if (selectedOtherItems.length === otherItems.length && firstItem) {
							otherItems.forEach(i => {
								i.classList.remove(this.classes.filterItemActive);
								const cb = i.querySelector('input[type="checkbox"]');
								if (cb) cb.checked = false;
							});
							firstItem.classList.add(this.classes.filterItemActive);
							const firstCb = firstItem.querySelector('input[type="checkbox"]');
							if (firstCb) firstCb.checked = true;
						}
					}
				}
			}
		}

		if (itemName && itemValue) {
			const relatedItems = document.querySelectorAll(`[data-name="${itemName}"][data-value="${itemValue}"], input[name="${itemName}"][value="${itemValue}"]`);
			relatedItems.forEach(relatedEl => {
				const relatedItem = relatedEl.closest('.filter__item, .filter__swatch, .filter__heading-item, .catalog-main__filters-item') || (relatedEl.classList.contains('catalog-main__filters-item') ? relatedEl : null);
				if (relatedItem && relatedItem !== item) {
					relatedItem.classList.toggle(this.classes.filterItemActive, isItemActive);
					const relCheckbox = relatedItem.querySelector('input[type="checkbox"]');
					if (relCheckbox) relCheckbox.checked = isItemActive;
				}
			});

			if (itemValue === 'all') {
				const otherRelatedItems = document.querySelectorAll(`[data-name="${itemName}"], input[name="${itemName}"]`);
				otherRelatedItems.forEach(otherEl => {
					const otherVal = otherEl.dataset?.value || otherEl.value;
					if (otherVal !== 'all') {
						const otherItem = otherEl.closest('.filter__item, .filter__swatch, .filter__heading-item, .catalog-main__filters-item') || (otherEl.classList.contains('catalog-main__filters-item') ? otherEl : null);
						if (otherItem && isItemActive) {
							otherItem.classList.remove(this.classes.filterItemActive);
							const otherCheckbox = otherItem.querySelector('input[type="checkbox"]');
							if (otherCheckbox) otherCheckbox.checked = false;
						}
					}
				});
			} else {
				const allItemsForCategory = document.querySelectorAll(`[data-name="${itemName}"][data-value="all"], input[name="${itemName}"][value="all"]`);
				allItemsForCategory.forEach(allEl => {
					const allItem = allEl.closest('.filter__item, .filter__swatch, .filter__heading-item, .catalog-main__filters-item') || (allEl.classList.contains('catalog-main__filters-item') ? allEl : null);
					if (allItem && isItemActive) {
						allItem.classList.remove(this.classes.filterItemActive);
						const allCheckbox = allItem.querySelector('input[type="checkbox"]');
						if (allCheckbox) allCheckbox.checked = false;
					}
				});
			}
		}

		if (!this.isMobile()) {
				if (this.debounceTimeout) {
					clearTimeout(this.debounceTimeout);
				}
				
				this.setLoadingState(true);
				
				this.debounceTimeout = setTimeout(() => {
					this.updateCatalogFromPage();
					this.debounceTimeout = null;
				}, 500);
		}
	}

	isAllDevicesSelected() {
		const itemLabel = document.querySelector('.filter__item-name[data-name=devices][data-value=all]');

		if (itemLabel) {
			const filterItem = itemLabel.closest('.filter__item');
			return filterItem?.classList.contains('is-active-filter');
		}

		return false;
	}

	disableSingularDevicesFilters() {
		const labels = document.querySelectorAll('.filter__item-name[data-name=devices]');
		labels.forEach((label) => {
			if (label.dataset.value !== 'all') {
				const filterItem = label.closest('.filter__item');
				filterItem?.classList.remove('is-active-filter');
			}
		});
	}

	checkTasteItems(currentItem, isCurrentActive) {
		const items = document.querySelectorAll('.filter__swatch');
		if (items.length === 0) return;

		const itemsWithTaste = Array.from(items).slice(1);
		const isAllTastesActive = itemsWithTaste.every(item => item.classList.contains(this.classes.filterItemActive))

		if (currentItem == items[0]) {
			itemsWithTaste.forEach((tasteItem) => {
				if (isCurrentActive) {
					tasteItem.classList.add(this.classes.filterItemActive);
				} else {
					tasteItem.classList.remove(this.classes.filterItemActive);
				}
			});

			return;
		}

		if (isAllTastesActive) {
			items[0].classList.add(this.classes.filterItemActive);
		} else {
			items[0].classList.remove(this.classes.filterItemActive);
		}
	}

	setLoadingState(state) {
		const catalog = document.querySelector(`.${this.classes.catalog}`);

		if (state) {
			catalog.classList.add('catalog--loading');
		} else {
			catalog.classList.remove('catalog--loading');
		}
	}

	updateCatalogFromPage(page, isInitialLoad = false, forceProducts = false) {
		this.setLoadingState(true);

		const activeFilters = {};
		let isAllSticks = false;
		let isAllDevices = false;
		let isAllAccessories = false;

		const activeItems = document.querySelectorAll(`.catalog__aside-products .${this.classes.filterItemActive}, .catalog-main__filters .${this.classes.filterItemActive}`);
		activeItems.forEach((item) => {

			const labelEl = item.querySelector('.filter__item-name, .filter__swatch-label, .filter__heading-text');
			const itemName = labelEl?.dataset.name || item.dataset.name || (item.querySelector('input[type="checkbox"]')?.name);
			const itemValue = labelEl?.dataset.value || item.dataset.value || (item.querySelector('input[type="checkbox"]')?.value);

			if (itemName && itemValue && itemValue != 'all') {
				if (activeFilters[itemName]) {
					const values = activeFilters[itemName].split(',');
					if (!values.includes(itemValue)) {
						activeFilters[itemName] += ',' + itemValue;
					}
				} else {
					activeFilters[itemName] = itemValue;
				}
			}

			if (itemName == 'devices' && itemValue == 'all') {
				isAllDevices = true;
			}
			if (itemName == 'sticks' && itemValue == 'all') {
				isAllSticks = true;
			}
			if (itemName == 'accessories' && itemValue == 'all') {
				isAllAccessories = true;
			}

		});

		const newUrl = this.generateUrl(activeFilters, page, isAllDevices, isAllSticks, isAllAccessories, forceProducts);

		this.loadCatalog(newUrl, isInitialLoad);
	}

	loadCatalog(newUrl, isInitialLoad = false, isPopState = false) {
		this.setLoadingState(true);

		this.controller?.abort();
		this.controller = new AbortController();

		fetch(newUrl, { signal: this.controller.signal })
			.then(response => {
				if (!response.ok) throw new Error('Network response was not ok');
				return response.text();
			})
			.then(html => {
				const parser = new DOMParser();
				const doc = parser.parseFromString(html, 'text/html');

				const productsTarget = document.querySelector('.catalog__products.collection-products');
				const newProducts = doc.querySelector('.catalog__products.collection-products');
				if (productsTarget && newProducts) {
					productsTarget.innerHTML = newProducts.innerHTML;
				}

				// Update page title
				const newTitle = doc.querySelector('title');
				if (newTitle) {
					document.title = newTitle.textContent;
				}

				// Update meta description
				const newMetaDesc = doc.querySelector('meta[name="description"]');
				const currentMetaDesc = document.querySelector('meta[name="description"]');
				if (newMetaDesc && currentMetaDesc) {
					currentMetaDesc.setAttribute('content', newMetaDesc.getAttribute('content'));
				}

				// Update canonical link
				const newCanonical = doc.querySelector('link[rel="canonical"]');
				const currentCanonical = document.querySelector('link[rel="canonical"]');
				if (newCanonical && currentCanonical) {
					currentCanonical.setAttribute('href', newCanonical.getAttribute('href'));
				}

				if (!isInitialLoad) {
					const titleEls = document.querySelectorAll('.catalog__main h1');
					const newTitle = doc.querySelector('.catalog__heading h1');

					if (titleEls.length && newTitle) {
						titleEls.forEach((titleEl) => {
							titleEl.innerHTML = newTitle.innerText.trim();
							titleEl.dataset.titleProducts = newTitle.innerText.trim();
						});
					}
				}

				this.updateFiltersState(doc);

				if (isPopState) {
					this.syncActiveFilters(doc);
					this.setTitle(document.querySelector('.catalog')?.classList.contains('catalog--xp') ? 'xp' : 'products');
				}

				const breadcrumbsEl = document.querySelector('.catalog__breadcrumbs');
				const newBreadcrumbs = doc.querySelector('.catalog__breadcrumbs');

				if (breadcrumbsEl && newBreadcrumbs) {
					breadcrumbsEl.innerHTML = newBreadcrumbs.innerHTML;
				}

				const seoTextEl = document.querySelector('.footer-description');
				const newSeoText  = doc.querySelector('.footer-description');
				if (seoTextEl && newSeoText) {
					seoTextEl.innerHTML = newSeoText.innerHTML;
				}

				const paginationEl = document.querySelector('#paginationCont');
				const newPagination = doc.querySelector('#paginationCont');

				if (paginationEl && newPagination) {
					paginationEl.innerHTML = newPagination.innerHTML;
				}

				if (!isInitialLoad && !isPopState) {
					this.setUrlString(newUrl);
				}

				this.renderFacets();
				this.setLoadingState(false);

				if (typeof this.seoCitySlider === 'function') {
					this.seoCitySlider();
				}

				window.dispatchEvent(new CustomEvent('catalog:update'));
				document.dispatchEvent(new CustomEvent('content:updated'));

			})
			.catch(error => {
				if (error.name === 'AbortError') return;

				console.error('Error updating catalog:', error);
				this.setLoadingState(false);
			});
	}

	generateUrl(filters, page, isAllDevices, isAllSticks, isAccessories, forceProducts = false) {
		let url = '';

		const locale = Shopify.locale == 'uk' ? '' : '/ru';
		const base = window.location.origin + locale + '/a/products';

		if (isAccessories) {
			url = `${base}/accessories`;
			
			const params = new URLSearchParams();

			if (filters.devices) {
				params.set(filters.devices.includes(',') ? 'devices' : 'device', filters.devices);
			} else if (isAllDevices) {
				params.set('devices', 'all');
			}

			if (filters.sticks) {
				params.set('sticks', filters.sticks);
			} else if (isAllSticks) {
				params.set('sticks', 'all');
			}

			if (params.toString()) {
				url += `?${params.toString().replaceAll('%2C', ',')}`;
			}
		} else {
			if (filters.devices && !filters.devices.includes(',') && !filters.sticks && !isAllSticks) {
				url = `${base}/${filters.devices}`;
			} else if (filters.devices && filters.devices.includes(',') && !filters.sticks && !isAllSticks) {
				url = `${base}/devices?devices=${filters.devices}`;
			} else if (filters.devices && filters.devices.includes(',') && (filters.sticks || isAllSticks)) {
				url = `${base}/devices?devices=${filters.devices}&sticks=${filters.sticks || 'all'}`;
			} else if (filters.devices && !filters.devices.includes(',') && (filters.sticks || isAllSticks)) {
				if (isAllSticks && !filters.sticks) {
					url = `${base}/${filters.devices}/sticks`;
				} else {
					url = `${base}/${filters.devices}/sticks?sticks=${filters.sticks}`;
				}
			} else if ((!filters.devices || isAllDevices) && (filters.sticks || isAllSticks)) {
				if (isAllSticks && !filters.sticks) {
					url = `${base}/sticks`;
				} else {
					url = `${base}/sticks?sticks=${filters.sticks}`;
				}
				if (isAllDevices) {
					url += (url.includes('?') ? '&' : '?') + 'devices=all';
				}
			} else if (isAllDevices && !filters.sticks && !isAllSticks) {
				url = `${base}/devices`;
			} else if (isAllSticks && !filters.devices && !isAllDevices) {
				url = `${base}/sticks`;
			}
		}

		if (url == '') {
			url = base;
		}

		const finalUrl = new URL(url);

		if (!forceProducts && (window.location.href.includes('bonus=yes') || window.location.href.includes('bonus'))) {
			finalUrl.searchParams.set('bonus', 'yes');
		}

		if (page && page !== 1) {
			finalUrl.searchParams.set('page', page);
		}

		url = finalUrl.toString().replaceAll('%2C', ',');

		// console.log('generated filter url:', url);

		this.lastUrl = url;

		return url;
	}

	renderFacets() {
		const facetsWrapper = document.querySelector('.catalog-main__filters:not(.catalog-main__filters--xp)');
		const clearBtnLabel = Shopify.locale == 'ru' ? 'Сбросить фильтры' : 'Скинути фільтри';

		if (!facetsWrapper) return;

		const activeItems = document.querySelectorAll(
			`.catalog__aside-products .${this.classes.filterItemActive}, 
  		 .catalog-main__filters .${this.classes.filterItemActive}`);

		const hasAllActive = Array.from(activeItems).some(item =>
			item.dataset.value === 'all' && item.dataset.name === 'all'
		);

		if (activeItems.length <= 0 || hasAllActive) {
			document.querySelector(`.${this.classes.clearFacets}`)?.remove();
			return;
		}

		const facetItemClear = document.createElement('button');
		facetItemClear.type = 'button';
		facetItemClear.classList.add(this.classes.facetItem, this.classes.clearFacetItem, this.classes.clearFacets);

		facetItemClear.innerHTML = `
				<span class="facets__item-label">${clearBtnLabel}</span>
		`;

		if(!facetsWrapper.querySelector(`.${this.classes.facetItem}`)){
			facetsWrapper.appendChild(facetItemClear);
		}

	}

	removeElement(element) {
		element?.remove();
	}

	setUrlString(urlString) {
		console.log('setUrlString()', 'urlString: ', urlString);

		if (urlString !== window.location.href) {
			window.history.pushState({}, '', urlString);
		}
		this.lastUrl = urlString;
		this.historyUrl = this.getHistoryUrl();
	}

	getHistoryUrl() {
		const url = new URL(window.location.href);
		url.hash = '';
		return url.href;
	}

	handlePopState = () => {
		const historyUrl = this.getHistoryUrl();
		if (historyUrl === this.historyUrl) return;

		this.historyUrl = historyUrl;

		const url = new URL(historyUrl);
		const isXp = url.searchParams.has('bonus');
		url.searchParams.delete('bonus');

		const catalogUrl = url.toString().replaceAll('%2C', ',');
		this.lastUrl = catalogUrl;

		this.setSwitchState(isXp);
		this.loadCatalog(catalogUrl, false, true);
	};

	setSwitchState(isXp) {
		document.querySelectorAll('.catalog__switches').forEach(switchContainer => {
			switchContainer.classList.toggle('catalog__switches--pos-1', !isXp);
			switchContainer.classList.toggle('catalog__switches--pos-2', isXp);
			switchContainer.querySelectorAll('.catalog__switch').forEach((btn, index) => btn.classList.toggle(this.classes.switchActive, index === (isXp ? 1 : 0)));
		});
		this.updateCatalogSwitchCurrentState();
		this.setPageState(isXp ? 'xp' : 'products');
	}

	syncActiveFilters(newPageHtml) {
		const selectors = '.catalog__aside-products :is(.filter__item, .filter__swatch, .filter__heading-item), .catalog-main__filters:not(.catalog-main__filters--xp) .catalog-main__filters-item';

		const getItemKey = (el) => {
			const label = el.querySelector('.filter__item-name, .filter__swatch-label');
			const checkbox = el.querySelector('input[type="checkbox"]');
			const name = label?.dataset.name ?? el.dataset.name ?? checkbox?.name;
			const value = label?.dataset.value ?? el.dataset.value ?? checkbox?.value;
			return `${el.classList[0]}-${name}-${value}`;
		};

		const newState = [...newPageHtml.querySelectorAll(selectors)].reduce((acc, item) => {
			acc[getItemKey(item)] = item.classList.contains(this.classes.filterItemActive);
			return acc;
		}, {});

		document.querySelectorAll(selectors).forEach((item) => {
			const isActive = !!newState[getItemKey(item)];
			item.classList.toggle(this.classes.filterItemActive, isActive);

			const checkbox = item.querySelector('input[type="checkbox"]');
			if (checkbox) checkbox.checked = isActive;
		});

		this.syncSelectWithMainFilters();
	}

	handleRemoveFacetClick = (event) => {
		const facetItem = event.target.closest(`.${this.classes.facetItem}`);
		const itemName = facetItem.dataset.name;
		const itemValue = facetItem.dataset.value;

		const filterItemLabels = document.querySelectorAll(`[data-name="${itemName}"][data-value="${itemValue}"]`);
		
		filterItemLabels.forEach((filterItemLabel) => {
			const filterItem = filterItemLabel.closest(`.${this.classes.filterItem}, .filter__swatch, .filter__heading-item, .catalog-main__filters-item`);

			if (filterItem) {
				filterItem.classList.remove('is-active-filter');
				const checkbox = filterItem.querySelector('input[type="checkbox"]');
				if (checkbox) checkbox.checked = false;
			}
		});

		this.removeElement(facetItem);
		this.updateCatalogFromPage();
	};

	updateFiltersAllProducts() {
		document.querySelectorAll('.catalog-main__filters-item').forEach(el => {
			const isAll = el.dataset.name === 'all' && el.dataset.value === 'all';
			el.classList.toggle(this.classes.filterItemActive, isAll);
		});

		const select = document.querySelector('#select-product');
		if (select) {
			const option = Array.from(select.options).find(opt => {
				const ov = opt.dataset.value || opt.value;
				return ov === 'all';
			});

			if (option) {
				select.value = option.value;

				if (select.tomselect) {
					select.tomselect.setValue(option.value, true);
				}
			}
		}
	}

	handleClearFacetsClick = (e) => {
		const activeFilterItems = document.querySelectorAll(`.${this.classes.filterItemActive}, .is-active-filter`);

		activeFilterItems.forEach((item) => {
			item.classList.remove('is-active-filter');
			const checkbox = item.querySelector('input[type="checkbox"]');
			if (checkbox) checkbox.checked = false;
		});

		e.target.closest('button')?.remove();

		this.updateFiltersAllProducts();

		this.updateCatalogFromPage();
	};

	handleCancelFilterXpClick = (e) => {
		const activeItems = document.querySelectorAll(
			`.catalog__aside-xp .${this.classes.filterItemActive},
     .catalog-main__filters--xp .${this.classes.filterItemActive}`
		);

		activeItems.forEach(item => {
			item.classList.remove(this.classes.filterItemActive);

			const checkbox = item.querySelector('input[type="checkbox"]');
			if (checkbox && checkbox.checked) {
				checkbox.checked = false;
			}
		});

		document.querySelector('button[data-name="all-xp"]')?.click();

		document.querySelectorAll('[name="category"][value="all"], [name="catalog_xp"][value="all"]').forEach(input => {
			input.checked = true;
			input.dispatchEvent(new Event('change', { bubbles: true }));
		});

		this.updateCatalogFromPage();
	};

	updateCatalogSwitchCurrentState() {
		document.querySelectorAll('.catalog__switches').forEach(switchContainer => {
			switchContainer.querySelectorAll('.catalog__switch').forEach((btn) => {
				if (btn.classList.contains(this.classes.switchActive)) {
					btn.setAttribute('aria-current', 'page');
				} else {
					btn.removeAttribute('aria-current');
				}
			});
		});
	}

	handleSwitchClick = (event) => {
		const currentPos = event.currentTarget.classList.contains('catalog__switches--pos-1') ? 1 : 2;
		const newPos = currentPos === 1 ? 2 : 1;

		document.querySelectorAll('.catalog__switches').forEach(switchContainer => {
			switchContainer.classList.replace(`catalog__switches--pos-${currentPos}`, `catalog__switches--pos-${newPos}`);
			switchContainer.querySelectorAll('.catalog__switch').forEach((btn, index) => btn.classList.toggle(this.classes.switchActive, index === (newPos - 1)));
		});
		this.updateCatalogSwitchCurrentState();

		this.setPageState(newPos === 1 ? 'products' : 'xp');
		this.setTitle(newPos === 1 ? 'products' : 'xp');
		this.urlTabSwitch(newPos);

		if (newPos == 1) {
			const oldSwiperAnnouncementBars = document.querySelectorAll('.new-product-announcement-bar');
			oldSwiperAnnouncementBars.forEach((barSlider) => {
				const barSliderInstance = barSlider.swiper;

				if (barSliderInstance) {
					barSliderInstance.destroy(true, true);
				}
			});

			window.dispatchEvent(new CustomEvent('catalog:update'));
			document.dispatchEvent(new CustomEvent('content:updated'));
		}
	};

	urlTabSwitch(tab) {
		let url;
		const locationPrefix = Shopify.locale == 'uk' ? '' : '/ru';

		if (tab == 2) {
			const tempUrl = new URL(window.location.origin + locationPrefix + '/a/products');
			tempUrl.searchParams.set('bonus', 'yes');
			url = tempUrl.toString();
		} else {
			url = this.lastUrl || `${locationPrefix}/a/products`;
			const tempUrl = new URL(window.location.origin + url);
			if (tempUrl.searchParams.has('bonus')) {
				tempUrl.searchParams.delete('bonus');
				url = tempUrl.pathname + tempUrl.search;
			}
		}

		window.history.replaceState({}, '', url);
	}

	addTitleDataAttributes() {
		const titleEls = document.querySelectorAll('.catalog__main h1');
		console.log('addTitleDataAttributes() titleEls', titleEls);

		if (titleEls.length) {
			if (window.location.href.includes('bonus')) {
				titleEls.forEach((titleEl) => {
					titleEl.dataset.titleProducts =  this.locale == 'ru' ? 'КАТАЛОГ ТОВАРОВ glo' : 'КАТАЛОГ ТОВАРІВ glo';
				});
			} else {
				titleEls.forEach((titleEl) => {
					titleEl.dataset.titleProducts = titleEl.innerText;
				});
			}

			titleEls.forEach((titleEl) => {
				titleEl.dataset.titleXp = this.locale == 'ru' ? 'КАТАЛОГ ТОВАРОВ - XP' : 'КАТАЛОГ ТОВАРІВ - XP';
			});
		}
	}

	setTitle(state) {
		const titleEls = document.querySelectorAll('.catalog__main h1');
		titleEls.forEach((titleEl) => {
			titleEl.innerText = state === 'xp' ? titleEl.dataset.titleXp : titleEl.dataset.titleProducts;
		});
	}

	setPageState(state) {
		const catalog = document.querySelector('.catalog');
		catalog.classList.toggle('catalog--xp', state === 'xp');
	}

	handleGroupHeadingClick = (event) => {
		const group = event.currentTarget.closest('.filter__group');
		const content = group?.querySelector('.filter__items');
		if (!content) return;

		const isExpanding = !group.classList.contains(this.classes.groupExpanded);
		content.style.height = isExpanding ? `${content.scrollHeight}px` : '0';
		group.classList.toggle(this.classes.groupExpanded);
		event.currentTarget.setAttribute('aria-expanded', isExpanding);
		if (isExpanding) {
			setTimeout(() => content.style.height = 'auto', 300);
		}
	};

	updateExpandedHeights = () => {
		document.querySelectorAll(`.${this.classes.groupExpanded}`).forEach(group => {
			const content = group.querySelector('.filter__items');
			content?.style.setProperty('--content-height', `${content.scrollHeight}px`);
		});
	};

	uncheckAllFilterCheckboxes() {
		const items = document.querySelectorAll('.filter__item.is-active-filter, .filter__swatch.is-active-filter, .catalog-main__filters-item.is-active-filter, .filter__heading-item.is-active-filter, .is-active-filter');

		items.forEach((filterItem) => {
			filterItem.classList.remove('is-active-filter');
			const checkbox = filterItem.querySelector('input[type="checkbox"]');
			if (checkbox) checkbox.checked = false;
		});
	}

	initToggleFilterAccessibility() {
		const aside = document.querySelector('.catalog__aside');
		const toggleButtons = document.querySelectorAll(`.${this.classes.toggleFilter}`);

		if (!aside || !toggleButtons.length) return;

		if (!aside.id) aside.id = 'catalog-filters-panel';

		const isExpanded = aside.classList.contains(this.classes.filterVisible);

		toggleButtons.forEach((button) => {
			button.setAttribute('aria-controls', aside.id);
			button.setAttribute('aria-expanded', isExpanded);
		});
	}

	updateToggleFilterExpandedState(isExpanded) {
		document.querySelectorAll(`.${this.classes.toggleFilter}`).forEach((button) => {
			button.setAttribute('aria-expanded', isExpanded);
		});
	}

	syncFilterPanelAccessibility() {
		const aside = document.querySelector('.catalog__aside');
		if (!aside) return;

		const shouldHide = this.isMobile() && !aside.classList.contains(this.classes.filterVisible);

		if (shouldHide) {
			aside.setAttribute('aria-hidden', 'true');
			aside.setAttribute('inert', '');
		} else {
			aside.removeAttribute('aria-hidden');
			aside.removeAttribute('inert');
		}
	}

	normalizeFilterTitleHeadings() {
		document.querySelectorAll('.catalog__aside .filter__title').forEach((title) => {
			if (title.tagName === 'H2') return;

			const heading = document.createElement('h2');

			Array.from(title.attributes).forEach((attr) => {
				heading.setAttribute(attr.name, attr.value);
			});

			while (title.firstChild) {
				heading.appendChild(title.firstChild);
			}

			title.replaceWith(heading);
		});
	}

	handleToggleFilterClick = (event) => {
		const aside = document.querySelector('.catalog__aside');
		if (!aside) return;

		const isExpanded = aside.classList.toggle(this.classes.filterVisible);
		document.body.classList.toggle('overflow', isExpanded);
		this.updateToggleFilterExpandedState(isExpanded);
		this.syncFilterPanelAccessibility();

		if (isExpanded) {
			aside.querySelector(`.${this.classes.asideClose}`)?.focus();
		}
	};

	handleAsideCloseClick = () => {
		const aside = document.querySelector('.catalog__aside');
		aside?.classList.remove(this.classes.filterVisible);
		document.body.classList.remove('overflow');
		this.updateToggleFilterExpandedState(false);
		document.querySelector(`.${this.classes.toggleFilter}`)?.focus();
		this.syncFilterPanelAccessibility();
	};

	handleSeoPriceClick = () => {
		const target = event.target.closest(".js-seo-price-section__more");

		if (target) {
			target.classList.toggle("active");
			const prevElement = target.previousElementSibling;
			if (prevElement) {
				prevElement.classList.toggle("less");
			}
		}
	};

	handleFilterApplyClick = () => {
		console.log('handleFilterApplyClick()');
		this.updateCatalogFromPage();
	};

	addEventListeners() {
		const events = [
			{ selector: '.catalog__switches', event: 'click', handler: this.handleSwitchClick },
			{ selector: '.catalog-main__filters-item', event: 'click', handler: this.handleMainFilters.bind(this) },
			{ selector: '#select-product', event: 'change', handler: this.handleSelectFilters.bind(this) },
			{ selector: `.${this.classes.removeFacet}`, event: 'click', handler: this.handleRemoveFacetClick },
			{ selector: `.${this.classes.clearFacets}`, event: 'click', handler: this.handleClearFacetsClick },
			{ selector: `.${this.classes.cancelFilterXp}`, event: 'click', handler: this.handleCancelFilterXpClick },
			{ selector: this.classes.groupHeading, event: 'click', handler: this.handleGroupHeadingClick },
			{ selector: `.${this.classes.toggleFilter}`, event: 'click', handler: this.handleToggleFilterClick },
			{ selector: `.js-filter-clear`, event: 'click', handler: this.clearFilter },
			{ selector: `.js-filter-apply`, event: 'click', handler: this.handleFilterApplyClick },
			{ selector: `.js-seo-price-section__more`, event: 'click', handler: this.handleSeoPriceClick },
			{ selector: `.${this.classes.asideClose}`, event: 'click', handler: this.handleAsideCloseClick }
		];

		events.forEach(({ selector, event, handler }) => {
			document.querySelectorAll(selector).forEach(element => element.addEventListener(event, handler));
		});

		document.body.addEventListener('click', (event) => {
			if (event.target.closest(`.${this.classes.removeFacet}`)) {
				this.handleRemoveFacetClick(event);
			} else if (event.target.closest(`.${this.classes.clearFacets}`)) {
				this.handleClearFacetsClick(event);
			}
		});

		document.body.addEventListener('click', (event) => {
			const xpFilterItem = event.target.closest('.catalog-main__filters--xp .catalog-main__filters-item');
			if (xpFilterItem) {
				const checkbox = xpFilterItem.querySelector('input[type="checkbox"]');
				if (checkbox) {
					event.preventDefault();
					checkbox.checked = !checkbox.checked;
					checkbox.dispatchEvent(new Event('change', { bubbles: true }));
				}
			}
		});
	}

	checkCatalogState() {
		const catalog = document.querySelector(`.${this.classes.catalog}`);
		if (catalog.classList.contains('catalog--xp')) {
			document.querySelectorAll('.catalog__switches').forEach(switchContainer => {
				switchContainer.classList.replace('catalog__switches--pos-1', 'catalog__switches--pos-2');
				switchContainer.querySelectorAll('.catalog__switch').forEach((btn, index) => btn.classList.toggle(this.classes.switchActive, index === 1));
			});
		}
		this.updateCatalogSwitchCurrentState();
	}

	handlePagination() {
		document.addEventListener('click', (event) => {
			if (event.target.closest('#catalogPager')) {
				event.preventDefault();
				const link = event.target.closest('a');
				console.log('pagination link', link);

				if (!link) return;

				const page = +link.dataset.page + 1 || null;

				console.log('pagination, go to page', page);
				this.updateCatalogFromPage(page)

				window.scrollTo({
					top: 0,
					left: 0,
					behavior: "smooth",
				});
			}
		});
	}

	duplicateNonAuthBannerForMobile() {
		const banner = document.querySelector('.banner-na');
		const target = document.querySelector('.catalog__xp--bg .catalog__xp-text');

		if (banner && target) {
			const bannerClone = banner.cloneNode(true);
			bannerClone.classList.add('banner-na--mobile');
			target.after(bannerClone);
		}
	}

	clearFilter = () => {
		this.uncheckAllFilterCheckboxes();
		this.updateFiltersAllProducts()

		const facetsWrapper = document.querySelector('.js-clear-facets');
		if (facetsWrapper) facetsWrapper.remove();
		
		this.updateCatalogFromPage();
	}

	updateFiltersState(newPageHtml) {
		const DISABLED_CLASSNAME = 'is-disabled';
		const selectors = '.filter__item, .filter__swatch, .filter__heading-item, .catalog-main__filters-item';
		const currentItems = document.querySelectorAll(selectors);
		const newItems = newPageHtml.querySelectorAll(selectors);

		// console.log('newItems', newItems);

		const getItemKey = (el) => {
			const label = el.querySelector('.filter__item-name, .filter__swatch-label');
			const name = label?.dataset.name ?? el.dataset.name;
			const value = label?.dataset.value ?? el.dataset.value;
			const text = el.innerText.trim();
			return `${name}-${value}-${text}`.toLowerCase();
		};

		const newState = [...newItems].reduce((acc, item) => {
			acc[getItemKey(item)] = item.classList.contains(DISABLED_CLASSNAME);
			return acc;
		}, {});

		[...currentItems].forEach((item) => {
			const key = getItemKey(item);
			item.classList.toggle(DISABLED_CLASSNAME, !!newState[key]);
		});
	}

	initSeoTextView() {
		document.addEventListener('click', (event) => {
			const target = event.target;

			if (target.classList.contains('js-expand-btn')) {
				const block = target.closest('.footer-description__inner');
				if (!block) return;

				const footerText = block.querySelector('.footer-description__text');
				const collapseBtn = block.querySelector('.js-collapse-btn');
				if (!footerText || !collapseBtn) return;

				footerText.classList.add('expanded');

				target.hidden = true;
				collapseBtn.hidden = false;
				collapseBtn.setAttribute('aria-expanded', 'true');
			}

			if (target.classList.contains('js-collapse-btn')) {
				const block = target.closest('.footer-description__inner');
				if (!block) return;

				const footerText = block.querySelector('.footer-description__text');
				const expandBtn = block.querySelector('.js-expand-btn');
				if (!footerText || !expandBtn) return;

				footerText.classList.remove('expanded');

				target.hidden = true;
				expandBtn.hidden = false;
				expandBtn.setAttribute('aria-expanded', 'false');
			}
		});
	}

	init() {
		this.prepareFilterItems();
		this.initToggleFilterAccessibility();
		this.syncFilterPanelAccessibility();
		this.normalizeFilterTitleHeadings();
		this.handleFilterItems();
		this.syncSelectWithMainFilters();
		this.addEventListeners();

		this.addTitleDataAttributes();
		this.handlePagination();
		this.seoCitySlider();
		this.duplicateNonAuthBannerForMobile();

		this.initSeoTextView();

		this.setLoadingState(false);

		setTimeout(() => {
			// init product cards color switches
			// window.ProductVariants.init();
		}, 1500);

		window.addEventListener('resize', this.updateExpandedHeights);
		window.addEventListener('popstate', this.handlePopState);

		window.addEventListener('resize', () => {
			this.renderFacets();
			this.syncFilterPanelAccessibility();
		});

		if (window.location.href.includes('bonus')) {
			this.uncheckAllFilterCheckboxes();
			this.updateCatalogFromPage(1, true, true);
		}

		this.checkCatalogState();

		this.renderFacets();
	}
}

export default CatalogFilter;
